<template>
	<div v-if="redirects.length || isAdmin" class="inline-flex flex-col gap-3">
		<short-url-embed-control
			v-for="(redirect, i) of redirects"
			:key="i"
			:redirect="redirect"
			:size="i === 0 ? 'small' : 'tiny'"
		/>
		<div v-if="isAdmin" class="text-center">
			<n-button
				tag="a"
				type="primary"
				text
				size="tiny"
				:href="`https://facile.webcloud.it/asiagoit/redirects/${encodeBase64(url)}`"
				target="_blank"
			>
				<template #icon>
					<n-icon>
						<i-carbon-movement />
					</n-icon>
				</template>
				Apri pannello redirect
			</n-button>
		</div>
	</div>
</template>

<script setup>
	import {NButton, NIcon} from 'naive-ui'
	import ICarbonMovement from '~icons/carbon/movement'
	import {Directus} from '@directus/sdk'
	import {encode as encodeBase64} from 'universal-base64url'
	import ShortUrlEmbedControl from './ShortUrlEmbedControl.vue'

	const props = defineProps({
		url: {
			type: String,
			required: true,
		},
		isAdmin: {
			type: Boolean,
			default: false,
		},
	})

	const directus = new Directus('https://nozomi.asiago.it')

	let redirects = (
		await directus.items('redirects').readByQuery({
			fields: ['id', 'from_path', 'use_prefix'],
			filter: {
				to_url: {
					_eq: props.url,
				},
			},
			sort: ['-created_at'],
			limit: -1,
		})
	).data

	if (!props.isAdmin) {
		redirects = [redirects[0]]
	}
</script>
